import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getCustomer = (token: string, backend: string, id) => {
    return fetch(`${getApiUrl(backend)}customers/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getCustomer